export default __webpack_public_path__ + "3f0df0c57698a80dfabb0b393ed2254f.jpeg";